import {StyledDetailsTabContentWrapper} from './style'

export const DetailsTabContentWrapper = StyledDetailsTabContentWrapper
